import * as React from 'react';

import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

import BaseIcon from '../BaseIcon';

type Props = CommonIconProps & {
  direction: 'asc' | 'desc';
};

const VIEWBOX = 16;

const Chevron: React.FC = () => (
  <g transform="translate(4 3.46) scale(1.2) translate(-4 -3.46)">
    <g transform="translate(0.42254 0)">
      <path
        d="M1.11475 4.98632C1.13996 5.04706 1.1769 5.10224 1.22346 5.14868C1.26991 5.19525 1.32508 5.23219 1.38583 5.2574C1.44657 5.2826 1.5117 5.29558 1.57746 5.29558C1.64323 5.29558 1.70835 5.2826 1.7691 5.2574C1.82984 5.23219 1.88502 5.19525 1.93146 5.14868L3.57746 3.50168L5.22346 5.14868C5.31735 5.24257 5.44469 5.29532 5.57746 5.29532C5.71024 5.29532 5.83758 5.24257 5.93146 5.14868C6.02535 5.0548 6.0781 4.92746 6.0781 4.79468C6.0781 4.66191 6.02535 4.53457 5.93146 4.44068L3.93146 2.44068C3.88502 2.39412 3.82984 2.35718 3.7691 2.33197C3.70835 2.30676 3.64323 2.29379 3.57746 2.29379C3.5117 2.29379 3.44658 2.30676 3.38583 2.33197C3.32509 2.35718 3.26991 2.39412 3.22346 2.44068L1.22346 4.44068C1.1769 4.48713 1.13996 4.54231 1.11475 4.60305C1.08954 4.6638 1.07657 4.72892 1.07657 4.79468C1.07657 4.86045 1.08954 4.92557 1.11475 4.98632Z"
        fill="currentColor"
      />
    </g>
  </g>
);

const SortDirectionIcon: React.FC<Props> = ({
  direction,
  svgProps: incomingSvgProps,
  ...rest
}: Props) => {
  const iconBody = (
    <>
      <rect
        x="3.25"
        y="3"
        width="1.5"
        height="11"
        rx="0.75"
        fill="currentColor"
      />
      <Chevron />
      <rect
        x="7.95"
        y="5.487"
        width="2.85"
        height="1.32"
        rx="0.66"
        fill="currentColor"
      />
      <rect
        x="7.95"
        y="8.671"
        width="4.7"
        height="1.32"
        rx="0.66"
        fill="currentColor"
      />
      <rect
        x="7.95"
        y="11.751"
        width="6.55"
        height="1.32"
        rx="0.66"
        fill="currentColor"
      />
    </>
  );

  return (
    <BaseIcon
      {...rest}
      iconSize={IconSize.XM}
      svgProps={{
        ...incomingSvgProps,
        viewBox: `0 0 ${VIEWBOX} ${VIEWBOX}`
      }}
    >
      {direction === 'desc' ? (
        <g transform={`translate(0 ${VIEWBOX})`}>
          <g transform="scale(1 -1)">{iconBody}</g>
        </g>
      ) : (
        iconBody
      )}
    </BaseIcon>
  );
};

export default SortDirectionIcon;
